import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles, PROFILER_IMAGES } from '../../Common/constants';
import { YesNoEnum } from '../../config/Profiler_enum';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { getQuestionConfig } from '../../config/questionsConfig';
const questionConfig = getQuestionConfig(ProfilerQuestionID.INSURANCE_INTEREST);

const Insurance = ({
  questionId = ProfilerQuestionID.INSURANCE_INTEREST,
  title = 'Would you like to earn Life/Medical Insurance based on your business performance?',
  options = questionConfig?.options || [],
  value,
  defaultValue = '',
  onChange,
  onSubmit,
}) => {
  const isControlled = typeof value === 'string';
  const [internalValue, setInternalValue] = useState(defaultValue);
  const selectedValue = isControlled ? value : internalValue;
  const handleSelect = (nextValue) => {
    if (!isControlled) {
      setInternalValue(nextValue);
    }
    onChange?.(nextValue);
    onSubmit?.({
      question: [
        { id: questionId, value: nextValue }
      ]
    });
  };
  return (
    <Box sx={cardStyles()}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
        <CardHeader title={title} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <Box component='img' alt='Life insurance' width={48} height={48} src={PROFILER_IMAGES.li} />
          <Typography variant='p3' sx={{ color: '#333333' }}>
            Life Insurance
          </Typography>

          <Box component='img' alt='Medical insurance' width={48} height={48} src={PROFILER_IMAGES.mi} />
          <Typography variant='p3' sx={{ color: '#333333' }}>
            Medical Insurance
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 'auto' }}>
          {options.map((option) => {
            const isSelected = selectedValue === option.value;
            return (
              <CustomButton
                key={option.value}
                label={option.label}
                variant={isSelected ? 'filled' : 'outlined'}
                size='small'
                onClick={() => handleSelect(option.value)}
                sx={{ width: '100%' }}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default Insurance;
